import * as math from 'mathjs';
import { UNIT_MAP, convertToUnit } from '../utils';
import { ValueUnit } from '../types/ValueUnit';

export function calculatePumpEfficiency(
    flowRate: number,
    flowRateUnit: string,
    pressure: number,
    pressureUnit: string,
    brakeHorsepower: number,
    brakeHorsepowerUnit: string,
): ValueUnit {
    if (brakeHorsepower === 0)
        throw new Error('Divide by 0 error. Brake horsepower cannot be 0');

    const _flowRateUnit = UNIT_MAP[flowRateUnit]
        ? UNIT_MAP[flowRateUnit]
        : flowRateUnit;
    const flowRateGpm = convertToUnit(
        math.unit(flowRate, _flowRateUnit),
        'gpm',
    );
    const _pressureUnit = UNIT_MAP[pressureUnit]
        ? UNIT_MAP[pressureUnit]
        : pressureUnit;
    const headFt = convertToUnit(math.unit(pressure, _pressureUnit), 'ftH2O');
    const _brakeHorsepower = convertToUnit(
        math.unit(brakeHorsepower, brakeHorsepowerUnit),
        'hp',
    );
    return {
        value: ((flowRateGpm * headFt) / (3960 * _brakeHorsepower)) * 100,
        unit: '%',
    };
}
export function calculateSpecificEnergy(
    flowRate: number,
    flowRateUnit: string,
    brakeHorsepower: number,
    brakeHorsepowerUnit: string,
): ValueUnit {
    if (flowRate === 0)
        throw new Error('Divide by 0 error. Flow rate cannot be 0');

    const brakeHorsepower_kW = convertToUnit(
        math.unit(brakeHorsepower, brakeHorsepowerUnit),
        'kW',
    );

    return {
        value: brakeHorsepower_kW / flowRate,
        unit: flowRateUnit.includes('/')
            ? `kW/(${flowRateUnit})`
            : `kW/${flowRateUnit}`,
    };
}
